import React from 'react';
import c from 'classnames';
import moment from 'moment';
import { Trans, useTranslation } from 'react-i18next';
import { Highlight } from 'react-instantsearch';

import Avatar from '../../../../Avatar';
import CoreLink from '../../../../CoreLink';
import type { SearchForumCommentHit as CommentHit } from '../../../types';
import Header from '../Header';

export interface SearchForumCommentHitProps {
  hit: CommentHit;
}

const SearchForumCommentHit: React.FC<SearchForumCommentHitProps> = (props) => {
  const { hit } = props;

  const { t } = useTranslation();

  const createdDate = moment.unix(hit.comment_created[0]);
  const postTitle = hit.comment_post_title[0];
  const message = hit.comment_message_searchable?.[0];
  const authorAvatar = hit.comment_author_avatar?.[0] || 1;
  const authorNickname = hit.comment_author_nickname?.[0] || t('pages.forum.anonymous');
  const commentLink = hit.comment_link?.[0] || '';
  const classes = c('SearchForum__Hit', 'SearchForum__Hit__Comment', 'u-link-box');

  return (
    <div className={classes}>
      <div className="SearchForum__Hit__inner">
        <Header entityType="comment" createdDate={createdDate} />

        <div className="SearchForum__Hit__author">
          <Avatar avatar={authorAvatar} />
          <div className="SearchForum__Hit__author__info">
            <Trans
              i18nKey="components.search_forum.results.hit.comment.nickname"
              values={{ nickname: authorNickname, postTitle }}
            />
          </div>
        </div>

        {message && commentLink && (
          <CoreLink className="SearchForum__Hit__link" href={commentLink}>
            <Highlight attribute="comment_message_searchable" hit={hit} />
          </CoreLink>
        )}
      </div>
    </div>
  );
};

export default SearchForumCommentHit;
